import { IMAGE_LIMITS, detectImageType } from "./image-pdf-core.js";

export { IMAGE_LIMITS };

export function validateHeicFile(file, header) {
  if (!file) return "No file was provided.";
  if (file.size > IMAGE_LIMITS.eachBytes) return "File exceeds the 25 MB limit.";
  if (detectImageType(header) !== "heic") return "Only valid HEIC and HEIF images are supported.";
  const extension = file.name?.toLowerCase().match(/\.([a-z0-9]+)$/)?.[1] || "";
  if (!["heic", "heif"].includes(extension)) return "File must use a .heic or .heif extension.";
  const mime = (file.type || "").toLowerCase();
  if (!["", "application/octet-stream", "image/heic", "image/heif"].includes(mime)) return "File MIME type is not HEIC or HEIF.";
  return null;
}

export function outputDetails(format) {
  if (format === "PNG") return { mime: "image/png", extension: "png" };
  if (format === "JPEG") return { mime: "image/jpeg", extension: "jpeg" };
  return { mime: "image/jpeg", extension: "jpg" };
}

export function outputFileName(sourceName, format) {
  const base = (sourceName || "image").replace(/\.[^.]+$/, "") || "image";
  return `${base}.${outputDetails(format).extension}`;
}

export function settingsKey(format, quality) {
  return format === "PNG" ? "PNG" : `${format}:${quality}`;
}
